// Valores por defecto de wordsOfCautionSga.
export const defaultWordsOfCautionSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionWordOfCaution = () => {
    return "";
};

// Valor por defecto de wordOfCaution.
export const defaultWordOfCaution = () => {
    return {
        id: null,
        name: null,
        priority: null,
        sga_word_of_caution_languages: [],
    };
};

// Valores por defecto de filterWordsOfCautionSga.
export const defaultFilterWordsOfCautionSga = () => {
    return {
        name: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeWordsOfCaution.
export const defaultActiveWordsOfCaution = () => {
    return [];
};

export default {
    wordsOfCautionSga: defaultWordsOfCautionSga(),
    action: defaultActionWordOfCaution(),
    wordOfCaution: defaultWordOfCaution(),
    filterWordsOfCautionSga: defaultFilterWordsOfCautionSga(),
    activeWordsOfCaution: defaultActiveWordsOfCaution(),
};
